import { render, staticRenderFns } from "./InstantTournamentHistoryModule.vue?vue&type=template&id=30a777dd&"
import script from "./InstantTournamentHistoryModule.vue?vue&type=script&lang=js&"
export * from "./InstantTournamentHistoryModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports